import * as React from 'react';
import Responsive from 'react-responsive';
import { MediaQueryProps } from 'react-responsive';

// export const Desktop = (props: MediaQueryProps) => <Responsive {...props} minWidth={768} />;
// export const Mobile = (props: MediaQueryProps) => <Responsive {...props} maxWidth={767} />;
export const Desktop = (props: MediaQueryProps) => <Responsive {...props} minWidth={1} />;
export const Mobile = (props: MediaQueryProps) => <Responsive {...props} maxWidth={0} />;